export default {
      id: "cybeam-usage",
      viewBox: "0 0 126 32",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#cybeam",
      toString: function () {
        return this.url;
      }
    }